import * as angular from 'angular';
import {IFilterCurrency, IFilterService} from "angular";

function urlEscapeFilter() {
    return encodeURIComponent;
}

export default angular.module('directives.urlEscape', [])
    .filter('urlEscape', urlEscapeFilter)
    .name;
